import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './News.css';

function NewsDetail() {
  const { id } = useParams();
  const [newsItem, setNewsItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`https://api.itosoba.ru/api/news/${id}`)
      .then(res => {
        if (!res.ok) throw new Error('Ошибка загрузки новости');
        return res.json();
      })
      .then(data => {
        setNewsItem(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, [id]);

  if (loading) return <p className="loading">Загрузка...</p>;
  if (error) return <p className="error">Ошибка: {error}</p>;
  if (!newsItem) return <p>Новость не найдена</p>;

  return (
    <div className="news-detail-container">
      <h2 className="news-detail-title">{newsItem.title}</h2>
      {newsItem.image_url && (
        <img
          src={`https://api.itosoba.ru${newsItem.image_url}`}
          alt={newsItem.title}
          className="news-detail-image"
        />
      )}
      <p className="news-detail-content">{newsItem.content}</p>
      <span className="news-detail-date">
        Дата: {new Date(newsItem.date).toLocaleString()}
      </span>
    </div>
  );
}

export default NewsDetail;